import { alpha, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  btnGrp: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  rotateScale: {
    transform: "scaleY(-1) rotate(180deg)",
    color: theme.custom.color.mortar,
  },
  chipContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    listStyle: "none",
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    backgroundColor: alpha(theme.custom.color.gainsboro, 0.5),
    borderRadius: "12.5px",
    flexDirection: "row-reverse",
    alignItems: "center",
    maxHeight: "24px",
    paddingRight: theme.spacing(0.5),
    marginRight: theme.spacing(1.25),
    "& .MuiChip-icon": {
      display: "flex",
      margin: 0,
      padding: 0,
      backgroundColor: alpha(theme.custom.color.white, 0.5),
    },
    "& .MuiChip-label": {
      display: "flex",
      fontWeight: 600,
      fontSize: "12px",
      letterSpacing: "0.2px",
      color: theme.custom.color.mortar,
      paddingRight: theme.spacing(1),
    },
  },
}));
